import { createContext, useContext } from "react";
import { Toaster } from "../components/Toaster";



const MessageContext = createContext({});

export const useMessageContext = () => useContext(MessageContext);
export function MessageProvider({ children }) {
    const msg = {};

    return (
      <MessageContext.Provider value={{ msg }}>
        <Toaster/>        
        {children}
      </MessageContext.Provider>
    );
  }
  
  // Custom hook for using ThemeContext
  export function useMessage() {
    const context = useContext(MessageContext);
    if (!context) throw new Error("useMessage must be used within a MessageProvider");
    return context;
  }